import { __assign } from "tslib";
export function formatMessage(formatters, spec) {
    if (!spec || (typeof spec !== 'string' && typeof spec.id === 'undefined')) {
        console.warn('formatMessage requires "id" property defined');
        return null;
    }
    var specObject = spec;
    // Create specObject if passed a string argument
    if (typeof spec === 'string') {
        specObject = {
            id: spec,
        };
    }
    var _a = specObject, id = _a.id, _b = _a.values, values = _b === void 0 ? {} : _b;
    var _c = formatters.preferences, locale = _c.locale, localeMode = _c.localeMode, messages = _c.messages;
    var formatter = formatters.getMessageFormatter(locale, messages, localeMode)(id);
    return formatter.format(values);
}
export function formatMessageToParts(formatters, id) {
    var _a = formatters.preferences, locale = _a.locale, localeMode = _a.localeMode, messages = _a.messages;
    var formatter = formatters.getMessageFormatter(locale, messages, localeMode)(id);
    return __assign(__assign({}, formatter.formatToParts()), { localeMode: localeMode });
}
